/* eslint-disable react/no-array-index-key, no-else-return, array-callback-return, consistent-return */

import { withStyles } from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import cn from 'classnames'

import ButtonGroup from '../ButtonGroup'
import { PrimaryAction, SecondaryAction } from './Renderers'
import RowActionMenu from './RowActionMenu'

const styles = theme => ({
  disableWrapper: {
    cursor: 'not-allowed',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: '2',
    '& > * + *': {
      marginLeft: '8px',
    },
    '& > span > * + *': {
      marginLeft: '8px',
    },
    '&.disableBtn': {
      pointerEvents: 'none',
      opacity: 0.7,
    },
  },
  menu: {
    '& > [type="button"]': {
      all: 'unset',
      width: 'auto',
      '&:disabled': {
        opacity: '0.5',
      },
    },
    '& > .item': {
      whiteSpace: 'nowrap',
      padding: '5px 20px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: theme.typography.fontSizeSm,
      color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
      textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: theme.rowAction.menuItemBgHover,
      },
      '&.disabled': {
        pointerEvents: 'none',
        opacity: '0.5',
        '&:hover': {
          cursor: 'not-allowed',
        },
      },
    },
  },
})

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
const RowActionRenderer = ({ actions, classes, width, white, disabled }) => {
  const rowActions = actions.filter(a => a !== false)

  if (rowActions.length === 0) {
    return null
  }

  return (
    <div className={disabled ? classes.disableWrapper : ''}>
      <div className={cn(classes.wrapper, 'noMargin', `${disabled ? 'disableBtn' : ''}`, 'row-action')}>
        {rowActions.length === 1 ? (
          <ButtonGroup>
            <PrimaryAction action={rowActions[0]} white={white} key={0} index={0} disabled={disabled} />
          </ButtonGroup>
        ) : (
          <RowActionMenu
            className={classes.menu}
            white={white}
            disabled={disabled || Object.values(actions).every(action => action.isDisabled === true)}
            isMobile
          >
            {rowActions.map((action, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              <SecondaryAction action={action} key={i} index={i} disabled={disabled} />
            ))}
          </RowActionMenu>
        )}
      </div>
    </div>
  )
}

RowActionRenderer.defaultProps = {
  white: false,
}

const RowActionRendererComponent = withStyles(styles)(RowActionRenderer)
const RowActionRendererWithWidth = withWidth()(RowActionRendererComponent)
RowActionRendererWithWidth.displayName = 'RowActionRenderer'
export default RowActionRendererWithWidth
